import { Map as MapboxMap, NavigationControl, ScaleControl } from 'mapbox-gl';
import {
  BOUNDS_SMALL,
  BOUNDS_LARGE,
  TILESET,
  STYLE,
  SOURCE,
  SOURCE_LAYER,
  TOKEN,
} from './maputils/constants';
// import { geocoder } from './maputils/geocoder';

let w = window.innerWidth;
const bounds = w < 500 ? BOUNDS_SMALL : BOUNDS_LARGE;

/**
 *
 * @param {Element} container
 */

export async function renderShapesMap(container) {
  // create our popup but don't add to the map for now

  // create our map - options you can add https://docs.mapbox.com/mapbox-gl-js/api/map/
  const map = new MapboxMap({
    accessToken: TOKEN,
    container,
    style: STYLE,
    // bounds,
    center: [-118.859, 34.2569],
    // center: [-118.25903553749211, 34.14229527144318],
    zoom: 8.1,
    cooperativeGestures: true,
  });

  // disable map rotation using right click + drag
  map.dragRotate.disable();
  // disable map rotation using touch rotation gesture
  map.touchZoomRotate.disableRotation();

  // Add controls to the map
  const geocoder = map.addControl(
    new MapboxGeocoder({
      accessToken: TOKEN,
      mapboxgl: map,
      countries: 'us',
      marker: false,
      bbox: [
        -120.85076250718006, 32.41265524142344, -113.88944068274624,
        36.196958080327256,
      ],
      types: 'address',
      zoom: 14,
    })
  );

  map.addControl(new NavigationControl({ showCompass: false }));
  map.addControl(new ScaleControl({ unit: 'imperial' }), 'bottom-right');

  // we wait for it to fully load so we can add sources and layers
  await map.once('load');

  // add our data source
  map.addSource(SOURCE, {
    type: 'vector',
    url: TILESET,
    // promoteId: 'some unique id in tileset like precinctID', // use this for most cases and comment out genreated ID below
    generatedId: true, // use this if your tileset was generated and uploaded using tippecanoe
    layout: {
      'fill-sort-key': ['+', ['get', 'PSPS']],
    },
  });

  //Adding geocoder

  // document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

  geocoder.on('result', function (e) {
    map.on('moveend', function () {
      var point = map.project(e.result.center);
      var feature = map.queryRenderedFeatures(point, {
        layers: ['hover-layer'],
      })[0];

      if (feature) {
        const featureId = feature.id;
        const props = feature.properties;

        setActiveId(featureId, props, e.result.center);
        popup.setLngLat(e.result.center);
        popup.setHTML(renderTooltip(props)).addTo(map);
      }
    });
  });
}
